import request from "../request"
import qs from "qs";


export function getDateList(params) {
  return request.get({
    url: "/rest/climate/datelist",
    params: params
  })
}
export function getRadarCloudPicData(params) {
  return request.get({
    url: "/rest/climate/common",
    params: params
  })
}
export function getConvectionData(params) {
  return request.get({
    url: "/rest/climate/convective",
    responseType: "blob",
    params: params
  })
}




